"use client";

import { Toaster as Sonner } from "sonner";
import styles from "./Toaster.module.css";

export function Toaster() {
  return (
    <Sonner
      closeButton
      position="bottom-left"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: styles.toast,
          content: styles.content,
          title: styles.title,
          description: styles.description,
          icon: styles.icon,
          closeButton: styles.closeButton,
          success: styles.success,
          error: styles.error,
        },
      }}
    />
  );
}
